import React from 'react'
import { Paper, Text, Stack, Group, Box } from '@mantine/core'
import { IconClock, IconDatabase, IconArchive } from '@tabler/icons-react'
import { ThemeConfig } from '../../utils/themeConfig'

interface ServiceCommitmentProps {
  themeConfig: ThemeConfig
}

export default function ServiceCommitment({ themeConfig }: ServiceCommitmentProps) {
  const services = [
    {
      icon: IconClock,
      label: '平均出报告时间',
      value: '15-60秒',
    },
    {
      icon: IconDatabase,
      label: '数据覆盖',
      value: '多源交叉校验',
    },
    {
      icon: IconArchive,
      label: '结果存档',
      value: '30天可回看',
    },
  ]

  return (
    <Paper
      p="lg"
      radius="lg"
      style={{
        border: `1px solid ${themeConfig.surfaceBorderColor}`,
        background: themeConfig.surfaceColor,
      }}
    >
      <Text size="lg" fw={600} mb="md">
        服务说明
      </Text>
      <Stack gap="md">
        {services.map((service, index) => (
          <Group key={index} gap="md" wrap="nowrap">
            <Box
              style={{
                padding: '8px',
                borderRadius: '8px',
                backgroundColor: `${themeConfig.primaryColor}15`,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                flexShrink: 0,
              }}
            >
              <service.icon size={20} color={themeConfig.primaryColor} />
            </Box>
            <div className="flex-1">
              <Text size="sm" c="dimmed" mb={2}>
                {service.label}
              </Text>
              <Text size="sm" fw={600} style={{ color: themeConfig.accentTextColor }}>
                {service.value}
              </Text>
            </div>
          </Group>
        ))}
      </Stack>
    </Paper>
  )
}
